import { AdminCohorts } from '@platform/client';
import { useQueryClient } from '@tanstack/react-query';
import { useContext, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';
import { AdminTableContext } from '../../AdminTable';
import { CohortForm, CohortFormData } from './CohortForm';

export const CreateCohortModal = ({ onClose }: { onClose: () => void }) => {
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const { ...functions } = useForm<CohortFormData>();
  const queryClient = useQueryClient();
  const createCohortMutator = AdminCohorts.useCreateCohort({
    mutation: {
      onMutate: () => setModalStage('submitting'),
      onError: () => setModalStage('error'),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [...AdminCohorts.getGetAdminCohortsQueryKey({ ...adminQueryOptionsV2 })],
        });
        setModalStage('success');
      },
    },
  });
  const onSubmit: SubmitHandler<CohortFormData> = async (data) => {
    if (
      data.name &&
      data.clientId &&
      data.engagementStartDate &&
      data.engagementEndDate &&
      data.wrapupDate &&
      data.kickoffDate &&
      data.applicationStartDate &&
      data.applicationEndDate &&
      data.duration &&
      data.timeCommitment &&
      data.templateId
    ) {
      createCohortMutator.mutate({
        data: {
          name: data.name,
          clientId: data.clientId,
          description: data.description ?? null,
          available: data.available ?? false,
          url: data.url ?? null,
          kickoffDate: data.kickoffDate,
          engagementStartDate: data.engagementStartDate,
          engagementEndDate: data.engagementEndDate,
          wrapupDate: data.wrapupDate,
          applicationStartDate: data.applicationStartDate,
          applicationEndDate: data.applicationEndDate,
          duration: data.duration,
          templateId: data.templateId,
          timeCommitment: data.timeCommitment,
        },
      });
    }
  };
  return (
    <AdminFormModal
      variant='full-screen'
      title='Create Cohort'
      modalStage={modalStage}
      onClose={onClose}
      submitCTA={{ text: 'Create Cohort', callback: () => functions.handleSubmit(onSubmit)() }}
    >
      <CohortForm {...functions} />
    </AdminFormModal>
  );
};
